//////////////////
// IMPORTS
//////////////////
// schema
// import * as ISchema from '@schema';
// libraries
import * as React from "react";
import { connect } from "react-redux";
// duration-picker imports
import { IContainer, IProps, IState } from "./DurationPicker.d";
import { styles } from "./DurationPicker.styles";
import { SidebarDialog } from "@clockwise/web-commons/src/components/sidebar-dialog";
// state
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import {
  Button,
  DialogContent,
  DialogActions,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class DurationPickerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      duration: props.defaultDuration,
      inputDialogOpen: false,
      inputDialogValue: "",
      inputDialogError: "",
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const duration = parseInt(e.target.value);
    this.onDurationChange(duration);
  };

  private onDurationChange = (duration: number, setStateCallback?: () => void) => {
    if (duration < 0) {
      return this.openInputDialog(true);
    }

    this.props.onDurationChange(duration);

    const inputDialogValue = duration === this.state.duration ? this.state.inputDialogValue : "";

    this.setState({ duration, inputDialogValue }, setStateCallback);
  };

  private openInputDialog = (inputDialogOpen: boolean) => {
    this.setState({ inputDialogOpen });
  };

  private onInputDialogChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputDialogValue = event.target.value;
    this.setState({ inputDialogValue, inputDialogError: "" });
  };

  private onInputDialogSubmit = () => {
    const { inputDialogValue } = this.state;
    const { maxDuration } = this.props;
    const duration = Math.round(Number(inputDialogValue));

    if (!duration) {
      return this.setState({ inputDialogError: "Please enter a valid duration" });
    }

    if (duration > maxDuration) {
      return this.setState({
        inputDialogError: `A duration over ${maxDuration} minutes isn't supported`,
      });
    } else if (duration < 1) {
      return this.setState({ inputDialogError: `A duration under 1 minute isn't supported` });
    }

    this.onDurationChange(duration, () => {
      this.openInputDialog(false);
    });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private maybeRenderDurationDialogInput = () => {
    return (
      <SidebarDialog
        isChromeExtension={this.props.isChromeExtension}
        open={this.state.inputDialogOpen}
        onClose={() => this.openInputDialog(false)}
      >
        <DialogContent>
          <FormControl error={!!this.state.inputDialogError}>
            <div style={{ width: "100%", display: "flex", alignItems: "baseline" }}>
              <TextField
                autoFocus
                type={"number"}
                value={this.state.inputDialogValue}
                onChange={this.onInputDialogChange}
                label="Meeting duration"
              />
              <div style={{ marginLeft: 10 }}>minutes</div>
            </div>
            {!!this.state.inputDialogError ? (
              <FormHelperText>{this.state.inputDialogError}</FormHelperText>
            ) : (
              ""
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.onInputDialogSubmit()} color="primary">
            Confirm
          </Button>
          <Button
            onClick={() => {
              this.setState({ inputDialogValue: "", inputDialogError: "" });
              this.openInputDialog(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </SidebarDialog>
    );
  };

  public render() {
    const { durations, disabled, showLabel, disableUnderline } = this.props;
    const { duration } = this.state;

    if (durations.indexOf(duration) === -1) {
      durations.unshift(duration);
    }

    return (
      <div className={this.props.classes.container}>
        <FormControl>
          {showLabel ? (
            <InputLabel className={this.props.classes.label} shrink htmlFor="cw-duration-picker">
              Duration
            </InputLabel>
          ) : (
            ""
          )}
          <Select
            value={duration}
            onChange={this.onSelectChange}
            name="Duration"
            disabled={!!disabled}
            inputProps={{
              name: "Duration",
              id: "cw-duration-picker",
            }}
            disableUnderline={disableUnderline}
          >
            {durations.map((d) => {
              return (
                <MenuItem key={d} value={d}>
                  {d} min
                </MenuItem>
              );
            })}
            <Divider />
            <MenuItem value={-1}>Custom</MenuItem>
          </Select>
        </FormControl>
        {this.state.inputDialogOpen ? this.maybeRenderDurationDialogInput() : ""}
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const DurationPickerStyled = withStyles(styles)(DurationPickerCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

export const DurationPicker = connect(mapStateToProps, {})(DurationPickerStyled);
